/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFriendliIsolatedLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_1154_4177)">
      <path
        d="M3.68364 7.38966C5.71805 7.38966 7.36727 5.73543 7.36727 3.69483C7.36727 1.65423 5.71805 0 3.68364 0C1.64922 0 0 1.65423 0 3.69483C0 5.73543 1.64922 7.38966 3.68364 7.38966Z"
        fill="white"
      />
      <path
        d="M3.68364 24C5.71805 24 7.36727 22.3458 7.36727 20.3052C7.36727 18.2646 5.71805 16.6104 3.68364 16.6104C1.64922 16.6104 0 18.2646 0 20.3052C0 22.3458 1.64922 24 3.68364 24Z"
        fill="white"
      />
      <path
        d="M11.0503 0.299072H13.5412C14.7194 0.299072 15.6794 1.25834 15.6794 2.44375V4.94223C15.6794 6.124 14.723 7.08692 13.5412 7.08692H10.7448C9.73393 7.08692 8.91211 6.2626 8.91211 5.24862V2.44375C8.91211 1.26199 9.86847 0.299072 11.0503 0.299072Z"
        fill="white"
      />
      <path
        d="M4.9861 15.3958H2.43701C1.25519 15.3958 0.298828 14.4365 0.298828 13.2511V10.7526C0.298828 9.56718 1.25519 8.60791 2.43701 8.60791H4.42246L5.8661 8.71004C7.00792 8.71004 7.12428 11.4237 7.12428 11.4237V13.2547C7.12428 14.4328 6.16065 15.3994 4.9861 15.3994V15.3958Z"
        fill="white"
      />
      <path
        d="M4.41797 8.60435C4.41797 8.60435 5.78888 8.65906 6.66524 8.11925C7.35251 7.69615 8.12706 6.9776 8.48706 6.12411C8.95252 5.01894 8.90888 3.90283 8.90888 3.90283L11.8362 7.08703C11.8362 7.08703 10.4943 7.01043 9.62524 7.46271C8.61433 7.99159 8.20342 8.54599 7.77433 9.21712C7.11979 10.242 7.11979 11.7229 7.11979 11.7229L4.41797 8.60435Z"
        fill="white"
      />
      <path
        d="M21.9306 0.397461H19.3015C18.1588 0.397461 17.2324 1.32664 17.2324 2.47284V5.10992C17.2324 6.25612 18.1588 7.1853 19.3015 7.1853H21.9306C23.0733 7.1853 23.9997 6.25612 23.9997 5.10992V2.47284C23.9997 1.32664 23.0733 0.397461 21.9306 0.397461Z"
        fill="white"
      />
      <path
        d="M13.6728 15.4941H11.0437C9.90188 15.4941 8.97461 14.564 8.97461 13.4188V10.7817C8.97461 9.63639 9.90188 8.7063 11.0437 8.7063H13.0946L14.2692 8.84125C15.411 8.84125 15.7419 9.63639 15.7419 10.7817V13.4188C15.7419 14.564 14.8146 15.4941 13.6728 15.4941Z"
        fill="white"
      />
      <path
        d="M12.5781 8.70632C12.5781 8.70632 14.069 8.78657 14.9854 8.40723C15.7854 8.07532 16.6763 7.14888 16.9309 6.38292C17.2327 5.46377 17.2327 4.22729 17.2327 4.22729L20.2436 7.19264C20.2436 7.19264 19.3636 7.13429 18.4436 7.61574C17.5781 8.06802 16.6981 8.96894 16.3345 9.68018C15.8727 10.5811 15.7454 12.4705 15.7454 12.4705L12.5818 8.70997L12.5781 8.70632Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1154_4177">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFriendliIsolatedLogo;
